import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMembersQuery = createQueryHook(MembershipsCreatorApiClient.getMembers, {
  queryKey: ['members'],
})
